module.exports = __webpack_public_path__ + "media/NvShen_1.0f8d2689.mp3";